const DataGrid = (theme) => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 0,
          color: theme.palette.text.primary,
          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
            {
              outline: "none", // Remove focus border for column headers
            },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none", // Remove focus border for cells
          },
          "& .MuiDataGrid-cell:focus": {
            outline: " none",
          },
        },
        row: {
          borderBottom: `1px solid ${theme.palette.divider}`, // Add border to separate rows
          "&:last-child": {
            borderBottom: "none", // Remove the border for the last row if desired
          },
        },
        cell: {
          lineHeight: "unset",
          borderColor: theme.palette.divider,
          "&:not(.MuiDataGrid-cellCheckbox)": {
            padding: theme.spacing(4),
            "&:first-of-type": {
              paddingLeft: theme.spacing(5),
            },
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(5),
          },
          "&:focus, &:focus-within": {
            outline: "none", // Remove focus border for cells
          },
        },
        columnHeaders: {
          backgroundColor: "#F1EBF7 !important",
          borderRadius: "12px",
        },
        columnHeader: {
          color: "#574766 !important",
          "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
            padding: theme.spacing(4),
            "&:first-of-type": {
              paddingLeft: theme.spacing(5),
            },
          },
          "&:last-of-type": {
            paddingRight: theme.spacing(5),
          },
        },
      },
      defaultProps: {
        rowHeight: 50,
        headerHeight: 54,
      },
    },
  };
};

export default DataGrid;
